// extracted by mini-css-extract-plugin
export var cancelButton = "_pk-5";
export var content = "_pk-3";
export var createButton = "_pk-6";
export var drawerContainer = "_pk-0";
export var footer = "_pk-2";
export var header = "_pk-1";
export var orderFormColumn = "_pk-4";